import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@mui/material"
import Button from "components/Button"
import { Formik } from "formik"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { recurringReminderName, reminderOptionName, validityOptionName } from "./helpers/nameSwitch"
import { RecertificationSection } from "./RecertificationSection"
import { AutomaticRemindersSection } from "./AutomaticReminderSection"
import { PeriodOfValiditySection } from "./PeriodOfValidity"
import { reminderValidationSchema } from "./helpers/reminderValidationSchema"

const ReminderSettingsForm = ({ examSummaryResult, handleSettingsSubmit, examSettingsResult, result }) => {
  const { t } = useTranslation("translation", { keyPrefix: "learning.admin.settings" })
  const formRef = useRef()

  const initialValues = examSettingsResult
    ? {
        ...examSettingsResult,
        reminders: Array.isArray(examSettingsResult.reminders) ? examSettingsResult.reminders : [],
        recertification: examSettingsResult.recertification
          ? examSettingsResult.recertification
          : {
              id: null,
              customerExaminationId: examSettingsResult?.id ?? null,
              isActive: false,
              startDate: null,
              endDate: null
            }
      }
    : {
        firstReminder: false,
        recurringReminderDays: "",
        recurringReminder: false,
        id: null,
        customerId: null,
        examinationId: null,
        periodOfValidity: null,
        sendFirstReminder: false,
        firstReminderInDays: null,
        sendRecurringReminders: false,
        recurringRemindersInDays: null,
        reminders: [],
        recertification: {
          id: null,
          customerExaminationId: null,
          isActive: false,
          startDate: null,
          endDate: null
        }
      }

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={reminderValidationSchema}
        onSubmit={(values, formikHelpers) => {
          handleSettingsSubmit(values, formikHelpers)
        }}
        enableReinitialize={true}>
        {({ handleSubmit, errors, touched, values, setFieldValue, setFieldTouched, submitCount }) => (
          <form id="CustomFieldForm" onSubmit={handleSubmit} noValidate>
            <Accordion sx={{ border: "none" }}>
              <AccordionSummary
                sx={{ py: "8px", px: "24px" }}
                expandIcon={<ExpandMoreIcon fontSize="large" />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography variant="h2">{t(`settings`, "Settings")}</Typography>{" "}
              </AccordionSummary>

              <AccordionDetails sx={{ p: 0 }}>
                <Box
                  px={{ xs: 2, sm: 3 }}
                  pb={{ xs: 2, sm: 3 }}
                  display="flex"
                  flexDirection="column"
                  gap={3}>
                  <PeriodOfValiditySection
                    t={t}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    examSummaryResult={examSummaryResult}
                    examSettingsResult={examSettingsResult}
                    validityOptionName={validityOptionName}
                    setFieldTouched={setFieldTouched}
                    submitCount={submitCount}
                  />

                  <AutomaticRemindersSection
                    t={t}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    examSettingsResult={examSettingsResult}
                    reminderOptionName={reminderOptionName}
                    recurringReminderName={recurringReminderName}
                  />

                  <RecertificationSection
                    t={t}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    submitCount={submitCount}
                  />

                  <Grid container direction="row" justifyContent="flex-end">
                    <Box>
                      <Button result={result} color="primary" type="submit">
                        {t(`button.save_settings`, "Save settings")}
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </AccordionDetails>
            </Accordion>
          </form>
        )}
      </Formik>
    </>
  )
}

export default ReminderSettingsForm